var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileServerDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b-icon-file-server",
    d: "M0 19c0 10.502 8.498 19 19 19s19-8.498 19-19S29.502 0 19 0 0 8.498 0 19z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a-icon-file-server",
    filterUnits: "objectBoundingBox",
    height: "127.3%",
    width: "127.3%",
    x: "-13.6%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "dilate",
    radius: 0.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a-icon-file-server)",
    xlinkHref: "#b-icon-file-server"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FBFBFB",
    xlinkHref: "#b-icon-file-server"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5498E0",
    d: "M10.29 15.127H32.4v5.528H10.29v-5.528zM29.637 17.2v1.382h1.382V17.2h-1.382zm-2.763 0v1.382h1.382V17.2h-1.382zm-2.764 0v1.382h1.382V17.2h-1.382z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3279C5",
    d: "M10.29 22.036H32.4v5.528H10.29v-5.528zm19.346 2.073v1.382h1.382v-1.382h-1.382zm-2.763 0v1.382h1.382v-1.382h-1.382zm-2.764 0v1.382h1.382v-1.382h-1.382z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileServerDefault);
export default __webpack_public_path__ + "static/media/file-server-default.9f1869ebd68b565e00834e95d55c77df.svg";
export { ForwardRef as ReactComponent };